import { StyleSheet, Text } from '@react-pdf/renderer'
import React from 'react'
import { ErrorBoundary } from '../../error-boundary'

const styles = StyleSheet.create({
	h2: {
		fontSize: 13,
		fontFamily: 'Inter',
		fontWeight: 'bold',
		marginBottom: 8,
		textAlign: 'left',
	},
})

const H2 = ({ children }: { children: React.ReactNode }) => (
	<ErrorBoundary message={'Error in H2'}>
		<Text style={styles.h2}>{children}</Text>
	</ErrorBoundary>
)

export default H2
